<template>
  <v-sheet>
    <div class="room-legend">
      <v-chip class="white--text" v-for="room in rooms" :key="room.id" :color="room.color">
        {{ room.title }}</v-chip
      >
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    rooms: Array
  }
}
</script>
<style scoped lang="scss">
.room-legend {
  display: flex;
  align-items: center;
  > *:not(:last-child) {
    margin-right: 8px;
  }
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 4px;
}
</style>
